import { useEffect } from 'react'
import { zdarzenie } from '../lib/pomiar'

/**
 * Pomiar ścieżki `/rynek` (prośba właściciela 2026-10-28: co robią ludzie z reklamy, którzy nie wystawiają zlecenia).
 * Anonimowo jak cały `lib/pomiar`: przedział czasu na stronie, progi przewinięcia i pierwsze kliknięcie albo wpis
 * w treści strony. Nigdy treść pól ani pozycja kursora. Kroki formularza wysyła `FormularzOgloszenia`.
 */

// Klucze przedziałów jak w backendzie (`pomiar/podsumowanie.py`, `CZASY_RYNKU`).
const PRZEDZIALY = [[10, 'do_10s'], [30, '10_30s'], [120, '30s_2min'], [300, '2_5min']]
export const przedzialCzasu = (sekundy) => (PRZEDZIALY.find(([granica]) => sekundy < granica) || [0, 'ponad_5min'])[1]
const PROGI = [25, 50, 75, 100]
// Podwójny efekt trybu deweloperskiego sprząta po kilku milisekundach: takiego „wyjścia” nie liczymy.
const MIN_MS = 500

const usePomiarRynku = (trescRef) => {
  useEffect(() => {
    const start = Date.now()
    // Przy przejściu w aplikacji sprzątanie biegnie już pod nowym adresem.
    const sciezka = window.location.pathname
    let czasWyslany = false
    let klik = false
    const progi = new Set()

    const wyslijCzas = (sprzatanie = false) => {
      if (czasWyslany) return
      const ms = Date.now() - start
      if (sprzatanie && ms < MIN_MS) return
      czasWyslany = true
      zdarzenie('rynek_czas', przedzialCzasu(ms / 1000), { sciezka })
    }
    // Schowanie karty to na telefonie często ostatni sygnał przed zamknięciem; liczymy czas do pierwszego.
    const naUkrycie = () => { if (document.visibilityState === 'hidden') wyslijCzas() }
    const naZamkniecie = () => wyslijCzas()
    const naPrzewiniecie = () => {
      const wysokosc = document.documentElement.scrollHeight
      if (!wysokosc) return
      const procent = ((window.scrollY + window.innerHeight) / wysokosc) * 100
      PROGI.forEach((p) => {
        // 2 punkty zapasu: dół strony rzadko wypada co do piksela.
        if (procent >= p - 2 && !progi.has(p)) { progi.add(p); zdarzenie('rynek_przewiniecie', String(p)) }
      })
    }
    const naKlik = () => {
      if (klik) return
      klik = true
      zdarzenie('rynek_krok', 'klik')
    }

    const tresc = trescRef?.current
    // `click` łapie też wybór klawiaturą i czytnikiem ekranu, `input` wpisywanie.
    const KLIKI = ['pointerdown', 'click', 'keydown', 'input']
    document.addEventListener('visibilitychange', naUkrycie)
    window.addEventListener('pagehide', naZamkniecie)
    window.addEventListener('scroll', naPrzewiniecie, { passive: true })
    KLIKI.forEach((k) => tresc?.addEventListener(k, naKlik))
    return () => {
      document.removeEventListener('visibilitychange', naUkrycie)
      window.removeEventListener('pagehide', naZamkniecie)
      window.removeEventListener('scroll', naPrzewiniecie)
      KLIKI.forEach((k) => tresc?.removeEventListener(k, naKlik))
      // Przejście w aplikacji na inną stronę (menu, „Moje zlecenia”).
      wyslijCzas(true)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
}

export default usePomiarRynku
